import { types } from 'mobx-state-tree';
import { VisitDtoModel, LocationStatus } from './models';
import getAppRoot from './utils/getAppRoot';

export const UnscheduledVisitRecord = types.model({
  key: types.string,
  visit: types.maybe(types.safeReference(types.late(() => VisitDtoModel))),
  disabled: types.boolean,
});

const Unscheduled = types.model('Unscheduled')
  .props({})
  .actions((self) => ({
    selectAll() {
      const { setSelectedItems } = getAppRoot(self).mapView;
      const selectedUnscheduledOrders = getAppRoot(self).mapView.selectedItems?.unscheduledOrders;
      const selectedUnscheduledOrdersCount = selectedUnscheduledOrders?.length;
      const allUnscheduledVisits = getAppRoot(self).ui.showQuestionableandInvalidOrders ? getAppRoot(self).unscheduledVisits.filter(v => (
        v.activeLocation && !v.activeLocation.bestMatch && v.locationStatus === LocationStatus.Validated) || v.locationStatus === LocationStatus.Invalid)
        : getAppRoot(self).unscheduledVisits;
      const allUnscheduledVisitsCount = allUnscheduledVisits.length;

      setSelectedItems({ unscheduledOrders: selectedUnscheduledOrdersCount !== allUnscheduledVisitsCount ? allUnscheduledVisits.map((v) => v.id) : [] });
    },
    deselectAll() {
      const { setSelectedItems } = getAppRoot(self).mapView;
      getAppRoot(self).ui.clearSelection();
      setSelectedItems({ unscheduledOrders: [] });
    },
  }));

export default Unscheduled;
